import { debounce } from 'lodash'

import Vue from 'vue'
import hyperform from 'hyperform'

import './plugins/vue-clipboard2'
import './plugins/vue-debounce'
import i18n from './plugins/vue-i18n'
import './plugins/vue-meta'
import vuetify from './plugins/vuetify'
import '~/polyfills/array-from'

import ActionFormApp from './ActionFormApp'
import ResponsiveGoalApp from './ResponsiveGoalApp'
import { detectIE } from '~/utils/browser'
import { openActionSocket } from '~/shared-vue-components/ActionForm/utils/websockets'

import store from './store'

import '~/assets/sass/public.scss'

import $ from 'jquery'
window.jQuery = $
window.$ = $

// Monkeypatch rsplit on to strings
// eslint-disable-next-line no-extend-native
String.prototype.rsplit = function (sep, maxsplit) {
  var split = this.split(sep)
  return maxsplit ? [split.slice(0, -maxsplit).join(sep)].concat(split.slice(-maxsplit)) : split
}

// Fix to ensure vh value doesn't change on a scroll action that resizes viewport height
const calcVH = () => {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

// Run on init
calcVH()

const debouncedCalcVH = debounce(calcVH, 200)

// Also run when window is resized
window.addEventListener('resize', () => {
  debouncedCalcVH()
})

// Attach openActionSocket function to window object
window.openActionSocket = openActionSocket

$(document).ready(() => {
  // Initialise Vue
  Vue.config.productionTip = false

  const ieVersion = detectIE()

  if (ieVersion) {
    // Only apply HTML5 form polyfill if internet explorer is detected
    hyperform(window)
  }

  // Initialise Action form(s)
  Array.from(document.getElementsByClassName('action-form-app')).forEach((actionFormEl, index) => {
    const props = { ...JSON.parse(actionFormEl.getAttribute('data')), ...$(actionFormEl).data() }
    // console.debug(props);

    // Initialise action websocket
    if (props.action_id && !window.actionSocket) {
      window.actionSocket = window.openActionSocket(props.action_id)
    }

    if (actionFormEl && props) {
      new Vue({
        render: h => h(ActionFormApp, { props }),
        i18n,
        vuetify,
        store
      }).$mount(actionFormEl)
    } else if (!actionFormEl) {
      // eslint-disable-next-line no-console
      console.error('Mounting element not found for action form')
    } else if (!props) {
      // eslint-disable-next-line no-console
      console.error('Required data on action form element not present')
    }

    // When a different language is selected, redirect to the appropriate translation
    const $form = $('form.language-selection')

    $form.find('select').change(function (evt) {
      const nextUrl = $(this).find('option:selected').data('next')
      window.location.href = nextUrl
    })
  })

  // Initialise Responsive goal section(s)
  Array.from(document.getElementsByClassName('responsive-goal-app')).forEach(responsiveGoalEl => {
    const props = {
      ...JSON.parse(responsiveGoalEl.getAttribute('data')),
      ...$(responsiveGoalEl).data()
    }

    if (responsiveGoalEl && props) {
      new Vue({
        render: h => h(ResponsiveGoalApp, { props }),
        i18n,
        vuetify,
        store
      }).$mount(responsiveGoalEl)
    } else if (!props) {
      // eslint-disable-next-line no-console
      console.error('Required data on responsive goal section element not present')
    }
  })
})
